import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import store from './store/store';

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import VueGtm from '@gtm-support/vue2-gtm';

Vue.config.productionTip = false
Vue.use(BootstrapVue);

const enableGtm = process.env.VUE_APP_ENABLE_GTM === "true";
Vue.use(VueGtm, {
  id: 'GTM-TPBTWCJ',
  enabled: enableGtm,
  debug: true,
  vueRouter: router,
  parentElement: document.head,
  loadScript: true,
});


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
